import React from "react";
import { InviteSuccess } from "../../components";

export default function Invite() {
  return (
    <div>
      <>
        <InviteSuccess />
      </>
    </div>
  );
}
